import { Divider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import ScoreImage from "../../images/scoreimage.png";
import useFinalScore from "./finalScoreStyle";

function FinalScore({ examResultData }) {
  const classes = useFinalScore();


  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={ScoreImage} alt="Score" />
      </div>
      <div className={classes.yourScore}>
        <Typography variant="caption">Your Score</Typography>
        <Typography variant="h6">
          {examResultData.summary.received_marks} /{" "}
          {examResultData.summary.total_marks}
        </Typography>
      </div>
      <div className={classes.incorrectCorrectTime}>
        <div className={classes.scoreItem}>
          <Typography variant="caption">INCORRECT</Typography>
          <Typography variant="h6">
            {examResultData.summary.incorrect_answer}
          </Typography>
        </div>
        <Divider className={classes.divider} orientation="vertical" flexItem />
        <div className={classes.scoreItem}>
          <Typography variant="caption">CORRECT</Typography>
          <Typography variant="h6">
            {examResultData.summary.correct_answer}
          </Typography>
        </div>
        <Divider className={classes.dividerlst} orientation="vertical" flexItem />
        <div className={classes.scoreItem}>
          <Typography variant="caption">PARTIAL CORRECT</Typography>
          <Typography variant="h6">
            {examResultData.summary.partialCorrectAnswers}
          </Typography>
        </div>
        <Divider className={classes.dividerlst} orientation="vertical" flexItem />
        <div className={classes.scoreItem}>
          <Typography variant="caption">NOT ATTEMPTED</Typography>
          <Typography variant="h6">
            {examResultData.summary.notAttempted}
          </Typography>
        </div>
        {/* <Divider className={classes.dividerlst} orientation="vertical" flexItem />
        <div className={classes.timetakencont}>
          <Typography variant="caption">TIME TAKEN</Typography>
          <Typography variant="h6">
            {examResultData.summary.time_taken} Minutes
          </Typography>
        </div> */}
      </div>
    </div>
  );
}

export default FinalScore;
